/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Travel_Start_Eta_LabelInputs */

const en_travel_start_eta_label = /** @type {(inputs: Travel_Start_Eta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected arrival`)
};

const ja_travel_start_eta_label = /** @type {(inputs: Travel_Start_Eta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`到着予定時刻`)
};

const fr_travel_start_eta_label = /** @type {(inputs: Travel_Start_Eta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure d'arrivée prévue`)
};

const de_travel_start_eta_label = /** @type {(inputs: Travel_Start_Eta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voraussichtliche Ankunft`)
};

/**
* | output |
* | --- |
* | "Expected arrival" |
*
* @param {Travel_Start_Eta_LabelInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const travel_start_eta_label = /** @type {((inputs?: Travel_Start_Eta_LabelInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Travel_Start_Eta_LabelInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_travel_start_eta_label(inputs)
	if (locale === "ja") return ja_travel_start_eta_label(inputs)
	if (locale === "fr") return fr_travel_start_eta_label(inputs)
	return de_travel_start_eta_label(inputs)
});